import React from "react";
import { InputEditVer1 } from "../UI/InputEditVer1";
import { SiteFormField } from "../UI/SiteFormField";

export const SITE_COORDINATS_HINT =
  "Получить координаты можно, в яндекс картах. Выбрать объект и скопировать координаты (Сверху слева в самом верху)";

export const SITE_COORDINATS_PLACEHOLDER = "Пример: 57.629026, 39.854530";

export function SiteCoordinatsField({ value, onChange }) {
  return (
    <SiteFormField label="Координаты">
      <p className="site-coords-hint">{SITE_COORDINATS_HINT}</p>
      <InputEditVer1
        className="site-form-control"
        value={value}
        onChange={onChange}
        placeholder={SITE_COORDINATS_PLACEHOLDER}
      />
    </SiteFormField>
  );
}
